import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const testimonials = [{
  quote: 'Nunca había hecho un asado solo en mi vida. La primera vez que lo hice con el sistema el vacío salió perfecto. Mi vieja no lo podía creer. Yo tampoco.',
  author: 'Tomás B.',
  age: '26 años',
  location: 'Buenos Aires'
}, {
  quote: 'Llevo diez años haciendo asados y siempre me faltaba algo. Ahora sé exactamente qué era: nunca tuve un sistema. El cronograma solo ya cambió todo.',
  author: 'Rodrigo M.',
  age: '38 años',
  location: 'Córdoba'
}, {
  quote: 'El chimichurri de 72 horas lo hice por primera vez y mi señora me preguntó qué había cambiado. Le dije que había cambiado el sistema. Eso solo ya vale la guita.',
  author: 'Mariana G.',
  age: '44 años',
  location: 'Buenos Aires'
}, {
  quote: 'El protocolo de rescate me salvó tres asados. El vacío crudo al centro lo cerré en aluminio y salió perfecto. Nadie se enteró de nada. Yo quedé como un capo.',
  author: 'Luciana F.',
  age: '36 años',
  location: 'Mendoza'
}, {
  quote: 'Lo del asado a la cruz lo leí tres veces antes de animarme. Cuando lo hice el cordero quedó tan bien que mi suegro que nunca dice nada me preguntó si había tomado clases.',
  author: 'Pablo S.',
  age: '47 años',
  location: 'Neuquén'
}, {
  quote: 'Por fin algo hecho para Argentina de verdad. Los cortes son los de acá, los nombres son los de acá, los precios son los de acá. Sin tener que traducir nada de afuera.',
  author: 'Claudia M.',
  age: '53 años',
  location: 'Santa Fe'
}];
export function Testimonials() {
  return <section className="py-20 bg-zinc-900 border-t border-zinc-800" data-id="element-262">
      <div className="container mx-auto px-4" data-id="element-263">
        <div className="text-center mb-16" data-id="element-264">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-265">
            LO QUE DICEN LOS QUE YA LO USAN
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 max-w-7xl mx-auto mb-16" data-id="element-266">
          {testimonials.map((t, i) => <div key={i} className="break-inside-avoid bg-zinc-950 border border-zinc-800 p-6 rounded-2xl shadow-lg" data-id="element-267">
              <div className="flex text-amber-500 mb-4" data-id="element-268">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-current" data-id="element-269" />)}
              </div>
              <p className="text-zinc-300 italic mb-6 leading-relaxed" data-id="element-270">
                "{t.quote}"
              </p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-271">
                <p className="font-bold text-white" data-id="element-272">{t.author}</p>
                <p className="text-xs text-zinc-500" data-id="element-273">
                  {t.age} · {t.location}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-274">
          <CTAButton data-id="element-275" />
        </div>
      </div>
    </section>;
}